jQuery(document).ready(function($){
    if ($('.request-call-back-block').length > 0) {
        $("#top-header").viewportChecker({
            offset:'0%',
            invertBottomOffset: true,
            repeat: true,
            callbackFunction: function(elem, action){
                if (action == 'add') {
                    $('.request-call-back-block').addClass('hide-rcl-block').removeClass('show-rcl-block');
                } else {
                    $('.request-call-back-block').addClass('show-rcl-block').removeClass('hide-rcl-block');
                }
            },
            scrollHorizontal: false 
        });
        if (!inViewport (document.getElementById("top-header"))) {
            $('.request-call-back-block').addClass('show-rcl-block').removeClass('hide-rcl-block');
        }
    }
}); 
